import classnames from "classnames"

import Loading from "../Loading"

import ButtonProps from "./ButtonProps"

import styles from "./styles.module.scss"

const Button = ({ children, loading = false, outline = false, disabled, onClick, ...restProps }: ButtonProps) => {
  return (
    <button
      className={classnames(styles["button"], {
        [styles["outline"]]: outline,
        [styles["loading"]]: loading,
        [styles["disabled"]]: disabled,
      })}
      disabled={disabled}
      onClick={onClick}
      {...restProps}>
      {!loading && children}
      <Loading loading={loading} />
    </button>
  )
}

export default Button
